import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import image from "../../../assets/img/marifer.png";

// Mismas medidas y distribución que las etiquetas QR de los rollos (StackCloth)
const styles = StyleSheet.create({
  qrImagen: {
    width: "140px",
    height: "140px",
    left: "0px",
  },
  image: {
    position: "relative",
    objectFit: "cover",
    zIndex: -999,
    width: "60px",
    height: "60px",
    left: "100px",
    marginBottom: "10px",
  },
  page: {
    fontSize: "9pt",
    padding: 10,
  },
  viewer: {
    width: "100%",
    height: window.innerHeight,
  },
  text5: {
    paddingLeft: "5px",
    fontSize: "11pt",
  },
  infoColumn: {
    flexDirection: "column",
    flex: 1,
    marginLeft: "6px",
    marginTop: "4px",
  },
  infoLine: {
    marginBottom: "3px",
    lineHeight: 1.2,
  },
  attrLine: {
    marginBottom: "2px",
    lineHeight: 1.2,
  },
});

// Lista de atributos de la variante (Color, Medida, etc.)
const getAttributes = (variant) =>
  (variant?.attributes || []).map(
    (a) => `${a.attributeName}: ${a.attributeValue}`
  );

const VariantLabelPdf = ({ data = [] }) => {
  const sorted = [...data].sort((a, b) => {
    const sa = a?.sku || "";
    const sb = b?.sku || "";
    if (sa < sb) return -1;
    if (sa > sb) return 1;
    return 0;
  });

  return (
    <PDFViewer style={styles.viewer}>
      <Document>
        {sorted.map((item, index) => {
          const attrs = getAttributes(item);
          return (
            <Page key={item.id ?? index} style={styles.page} size={[286, 223]}>
              <View style={styles.text5}>
                <Text>{`Insumo: ${item?.insumo?.nombre ?? ""}`}</Text>
              </View>
              <View style={{ flexDirection: "row", marginTop: "2px" }}>
                <Image style={styles.qrImagen} src={item.dataURL} />
                <View style={styles.infoColumn}>
                  <Text style={styles.infoLine}>{`SKU: ${item?.sku ?? ""}`}</Text>
                  <Text style={styles.infoLine}>{`Codigo: ${
                    item?.insumo?.codigo ?? "-"
                  }`}</Text>
                  <Text style={styles.infoLine}>Variante:</Text>
                  {attrs.length > 0 ? (
                    attrs.map((a, i) => (
                      <Text key={i} style={styles.attrLine}>{`\u2022 ${a}`}</Text>
                    ))
                  ) : (
                    <Text style={styles.attrLine}>-</Text>
                  )}
                </View>
              </View>
              <Image style={styles.image} src={image} />
            </Page>
          );
        })}
      </Document>
    </PDFViewer>
  );
};

export default VariantLabelPdf;
